module.exports = __webpack_public_path__ + "img/ИФ-1(А)-003.df132eed.png";